import { combineReducers } from "redux";

import user from "./user";
import vendor from "./vendor";
import job from "./job";
import calendar from "./calendar";
import project from "./project";
import campaign from "./campaign";
import client from "./client";
import qa from "./qa";
import stat from "./stat";
import purchaseOrder from "./purchaseOrder";
import invoice from "./invoice";
import payment from "./payment";
import cron from "./cron";

import notificationGroup from "./notificationGroup";

export default combineReducers({
    user,
    vendor,
    job,
    calendar,
    project,
    campaign,
    notificationGroup,
    client,
    stat,
    purchaseOrder,
    invoice,
    payment,
    qa,
    cron,
});
